<template>
  <gjw-tabs ref="detailViewsTab" class="detail-views" :tabs="tabs" @tab-clicked="onTabClicked" size="small">
    <template #content-thumbnails >
      <el-carousel
        class="view-container"
        height="128px"
        :arrow="thumbnails && thumbnails.length > 1 ? 'always' : 'never' "
        :indicator-position="thumbnails && thumbnails.length > 1 ? 'outside': 'none'"
        trigger="click" >
        <el-carousel-item  v-for="(item, index) in thumbnails" :key="index">
          <img class="thumbnail" :src="item" alt="">
        </el-carousel-item>
      </el-carousel>
    </template>
    <template #content-3d>
      <gjw-three-viewer
        class="three-container 3d-container"
        v-if="['g', 'cs'].includes(platform)"
        :show="currentView==='3d'"
        :family-type="currentType"
        :store-id="detail.storeId"
        :core-resource-id="detail.coreResourceId"
        :core-resource-version-id="detail.digitalComponentId"
        :geometry-data="geometryData"
        :api="threeApi"
        :input-parameters="inputParameters"
      />
      <gjw-bimface-viewer
        class="three-container view-container"
        v-else
        :family-type="(currentType && currentType.name) || ''"
        :view-token="viewToken"
      />
    </template>
    <template #content-placeholder>
      <el-carousel
        class="view-container"
        height="128px"
        :arrow="placeholders && placeholders.length > 1 ? 'always' : 'never' "
        :indicator-position="placeholders && placeholders.length > 1 ? 'outside': 'none'">
        <el-carousel-item v-for="(placeholder,i) in placeholders" :key="i">
          <div class="placeholder-thumbnail-wrap flex-container flex-column">
            <p class="title line-no-wrap">
              {{ placeholder.discipline ? `${switchPlaceholderType(placeholder.placeholderType)}-${switchPlaceholderMajor(placeholder.discipline)}` : `${switchPlaceholderType(placeholder.placeholderType)}` }}
            </p>
            <div class="image-wrapper flex-item flex-item-grow flex-container flex-column flex-horiz-center flex-verti-center">
              <img class="holder-thumbnail" :src="placeholderThumbnail(placeholder.thumbnail)" alt="">
              <p class="holder-name line-no-wrap">
                {{ placeholder.name }}
              </p>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </template>
  </gjw-tabs>
</template>

<script>
import GjwTabs from '@/components/lib/GjwTabs'
import GjwBimfaceViewer from '@/components/lib/GjwBimfaceViewer'
import GjwThreeViewer from '@/components/lib/GjwThree'
export default {
  components: {
    GjwTabs,
    GjwBimfaceViewer,
    GjwThreeViewer
  },
  props: {
    platform: {
      type: String,
      default: ''
    },
    detail: {
      type: Object,
      default() {
        return {}
      }
    },
    thumbnails: {
      type: Array,
      default() {
        return []
      }
    },
    currentType: {
      type: Object,
      default() {
        return {}
      }
    },
    geometryData: {
      type: Array,
      default() {
        return []
      }
    },
    viewToken: {
      type: String,
      default: ''
    },
    threeApi: {
      type: String,
      default: ''
    },
    placeholders: {
      type: Array,
      default() {
        return []
      }
    },
    inputParameters: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      currentView: 'thumbnails'
    }
  },
  computed: {
    showThreeDimension() {
      if (this.platform === 'g') {
        return this.detail && this.detail.thumbnailType === '3d'
      }
      return true
    },
    tabs() {
      const thumbnailTab = { name: '缩略图', id: 'thumbnails' }
      const threeTab = { name: '3D', id: '3d' }
      const placeholderTab = { name: '图例', id: 'placeholder' }
      if (this.platform === 'g' && this.showThreeDimension && this.detail.hasPlaceholder) {
        return [thumbnailTab, threeTab, placeholderTab]
      } else if (this.platform === 'g' && !this.showThreeDimension && this.detail.hasPlaceholder) {
        return [thumbnailTab, placeholderTab]
      } else if (this.platform === 'g' && !this.showThreeDimension && !this.detail.hasPlaceholder) {
        return [thumbnailTab]
      }
      return [thumbnailTab, threeTab]
    }
  },
  methods: {
    onTabClicked({ id }) {
      this.currentView = id
      this.$emit('change-view', id)
    },
    placeholderThumbnail(placeholder) {
      return `${process.env.VUE_APP_STATIC_HOST}/${placeholder}`
    },
    // 图例类型转换
    switchPlaceholderType(value) {
      switch (value) {
        case 'PROFILE': return '侧面图例'
        case 'ELEVATION': return '立面图例'
        case 'PLAN': return '平面图例'
      }
    },
    // 图例专业转换
    switchPlaceholderMajor(value) {
      switch (value) {
        case 'COMMON': return '通用'
        case 'ELECTRIC': return '电气'
      }
    }
  }
}
</script>

<style lang="less" scoped>
.view-container{
  padding-top: 16px;
}
.three-container{
  // width: 260px!important;height: 260px!important;
    height: 175px!important;
  }
.thumbnail{
  height: 100%;
}
.placeholder-thumbnail-wrap{
  width: 128px;height: 124px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 0 4px 0 rgba(136, 146, 180, 0.5);
  .title {
    background-color: #F5F5FA;
    width: 100%;
    text-align: center;
    height: 24px;
    line-height: 24px;
  }

  .holder-thumbnail{
    width: 74px;height: 74px;
  }
  .holder-name{
    height: 16px;
    line-height: 16px;
    text-align: center;
    color: #303133;
  }
}
 /deep/.el-carousel__item{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
</style>
